import {inject, observer} from 'mobx-react';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import StoryblocksStore from '../store/StoryblocksStore';
import BrowseStoryblocksUI from '../view/BrowseStoryblocksUI';
import {useParams} from 'react-router-dom';
import ModalDialog from '../../ModalDialog/ModalDialog';

interface Props {
  chunkId: string;
  onCancel: () => void;
  onSelect: (storyBlocksVideoId: string, chunkId: string) => void;
  storyblocksStore?: StoryblocksStore;
}

const BrowseStoryblocksContainer = inject('storyblocksStore')(
  observer(({chunkId, onCancel, onSelect, storyblocksStore}: Props) => {
    const {organizationId} = useParams();
    const [page, setPage] = useState(0);
    const [pageSize] = useState(50);
    const [search, setSearch] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoadCompleted, setFirstLoadCompleted] = useState(false);
    const isLoadingRef = useRef(false);

    useEffect(() => {
      if (organizationId && storyblocksStore) {
        storyblocksStore.reset();
        setPage(0);
        loadData(0);
      }
    }, [search]);

    const loadData = async (pageToLoad: number) => {
      if (isLoadingRef.current || !storyblocksStore!.hasMore) return;
      isLoadingRef.current = true;
      setIsLoading(true);
      await storyblocksStore?.appendStoryblocksMedia(
        organizationId!,
        chunkId,
        pageToLoad,
        pageSize,
        search,
      );
      setPage(pageToLoad + 1);
      setFirstLoadCompleted(true);
      setIsLoading(false);
      isLoadingRef.current = false;
    };

    const onLoadMore = useCallback(() => {
      loadData(page);
    }, [page]);

    const onSearch = (s: string) => {
      storyblocksStore!.reset();
      setPage(0);
      setSearch(s);
      //useEffect will do the loadData(0) because it depends on search
    };

    return (
      <ModalDialog onClose={onCancel} isLoading={!firstLoadCompleted}>
        <BrowseStoryblocksUI
          isLoading={isLoading ?? true}
          mediaItems={storyblocksStore!.mediaItems}
          hasMore={storyblocksStore!.hasMore}
          onLoadMore={onLoadMore}
          search={search}
          onSearch={onSearch}
          onClose={onCancel}
          onSelect={storyBlocksVideoId => onSelect(storyBlocksVideoId, chunkId)}
        />
      </ModalDialog>
    );
  }),
);

export default BrowseStoryblocksContainer;
